import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.element.showModal()
  }

  close() {
    this.element.close()
  }

  backdropClose(event) {
    if (event.target === this.element) this.close()
  }

  clear() {
    const frame = this.element.closest('turbo-frame')
    this.element.remove()
    frame?.removeAttribute('src')
  }
}
